var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AttachmentBtnBase text-no-wrap",class:{
      'AttachmentBtnBase--large': _vm.large,
      'AttachmentBtnBase--mobile': _vm.isSmallToolboxSize,
      'AttachmentBtnBase--currentBtn': _vm.isActive,
      'AttachmentBtnBase--disabled': _vm.isDisabled,
    },on:{"click":function($event){_vm.$emit('click')}}},[_vm._t("icon"),_vm._v(" "),(!_vm.isSmallToolboxSize)?_c('span',{staticClass:"AttachmentBtnBase__text"},[_vm._t("text")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }